<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row">
          <el-table-column label="周转物" width="170" prop="name_type" align="center"></el-table-column>
          <el-table-column label="外库" width="170" prop="external_name" align="center"></el-table-column>
          <el-table-column label="入库1" prop="in_store1" width="150" align="center"></el-table-column>
          <el-table-column label="入库2" prop="in_store2" width="150" align="center"></el-table-column>
          <el-table-column label="出库1" prop="out_store1_normal" width="150" align="center"></el-table-column>
          <el-table-column label="出库2" prop="out_store2_normal" width="150" align="center"></el-table-column>
          <el-table-column label="废弃1" prop="out_store1_discard" width="150" align="center"></el-table-column>
          <el-table-column label="废弃2" prop="out_store2_discard" width="150" align="center"></el-table-column>
          <el-table-column label="在库数量" width="150" align="center">
            <template slot-scope="scope">
              {{cacuCount(scope.row.in_store2,scope.row.out_store2_normal,scope.row.out_store2_discard)}}
            </template>
          </el-table-column>
          <el-table-column label="丢失数量" prop="discount" width="150" align="center"></el-table-column>
          <el-table-column></el-table-column>
        </el-table>
      </div>
    </div>
    <!--列表数据 结束-->
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      ds: []
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData()
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getDailySummaryList, {}, function(res) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist.filter(item =>{
            return item.in_store1 !== '0' && item.in_store1 !== ''
          });
        }
      });
    },
    // 刷新事件
    refreshHandler: function() {
       this.loadData();
    },
    cacuCount: function(in_store2,out_store2_normal,out_store2_discard) {
      if(parseInt(out_store2_normal) === 0 && parseInt(out_store2_discard) === 0) {
        return parseInt(in_store2)
      } else {
        return 0;
      }
    },
    cacuDisCount: function(in_store2,out_store2_normal,out_store2_discard) {
      if(parseInt(out_store2_normal) !== 0 || parseInt(out_store2_discard) !== 0) {
        return parseInt(in_store2) - parseInt(out_store2_normal) - parseInt(out_store2_discard)
      } else {
        return 0;
      }
    }
  },
  components: {}
};
</script>
